import backendURLs from '~/misc/backendURLs';

export default (axios, code) => {
  return axios
    .get(`${backendURLs.payoutCodes}/${code}`)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
